"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validHTMLElement;

function validHTMLElement(props, propName) {
  var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ANONYMOUS';

  if (typeof window === 'undefined') {
    return null;
  }

  if (props[propName]) {
    var value = props[propName];
    var isValid = value instanceof window.Element;

    if (!isValid) {
      return new Error("Prop name \"".concat(propName, "\" in <").concat(componentName, "> must be an HTML DOM element."));
    }
  }

  return null;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-parallax/cjs/utils/validHTMLElement.js
// module id = 307
// module chunks = 0